// extracted by mini-css-extract-plugin
module.exports = {"profile_menu_warapper":"ProfileMenu_profile_menu_warapper__UJHry"};